const warehouse = {
  inventoryOrderList: '구매 주문 입고',
  orderNumber: '주문 번호',
  documentNumber: '문서 번호',
  changeType: '변경 유형',
  lot: '배치',
  quantity: '수량',
  totalIn: '총 입고',
  totalOut: '총 출고',
  inventory: '재고',
  balance: '잔액',
  plSelectProduct: "제품을 선택해 주세요",
  plProductNum: "제품 수량을 입력해 주세요",
  productNumMin: "제품 수량 최소값은 {{ num }}입니다",
  addProduct: "제품 정보 추가",
  addProductForm: "{{ name }} 양식 작성",

  inbound: '입고',
  outbound: '출고',

  deliveryOrderNumber: '배송(입고) 주문 번호',
  materialRequisitionNumber: '자재 요청(출고) 주문 번호',

  inboundOprt: '입고하려면',
  outboundOprt: '출고하려면',
  outboundError: '출고 실패',
  outboundSuccess: '출고 성공',
  insufficientInventory: '재고 부족',
  forceOutbound: '강제 출고 하시겠습니까?',
  forceOutboundFailed: '강제 출고 실패',
  inboundError: '입고 실패',
  outboundNotEnough: '재고 수량 부족',
  returnStock: '반품',
  returnStockSuccess: '반품 성공',
  returnStockFail: '반품 실패',
  returnQuantity: '반품 수량',
  selectLocationToReturn: '반품할 위치 선택',
  selectLocationToInbound: '입고 위치 선택',
  available: '사용 가능',
  returnExceedsAvailable: '반품 수량이 사용 가능 수량을 초과합니다',
  returnExceedsOriginal: '반품 수량이 원래 주문 수량 {{original}}을 초과합니다',
  validationError: '검증 실패',
  sourcesPick: '자재 픽킹',
  pickingOutbound: '픽킹 출고',
  sourcesInReturn: '입고 주문 반품',
  sourcesOutReturn: '출고 주문 반품',

  numDetail: '수량 입력 세부정보',
  productNum: '제품 수량',

  arrivalAt: '도착 시간',
  remark: '비고',
  enterRemark: '비고를 입력해 주세요',
  requiredArrivalAt: '요청된 도착 시간',
  actualArrivalAt: '실제 도착 시간',
  plArrivalAt: '도착 시간을 입력해 주세요',
  startTime: '시작 시간',
  endTime: '종료 시간',
  deliveryStartTime: '배송 시작 시간',
  deliveryEndTime: '배송 종료 시간',
  plProduct: '제품을 선택해 주세요',
  inQuantity: '입고 수량',
  plInQuantity: '입고 수량을 입력해 주세요',
  outQuantity: '출고 수량',
  plOutQuantity: '출고 수량을 입력해 주세요',
  codeRepeat: '바코드 중복, 삭제 후 다시 시도해 주세요',
  orderType: '입고 주문 유형',
  inOrder: '입고 주문',
  preInOrder: '배송 주문 입고(사전 입고)',
  purchaseOrder: '구매 주문',
  selectOrderType: '입고 주문 유형을 선택해 주세요',
  selectOrderNumber: '입고 주문 번호를 입력해 주세요',
  numberNotExist: '주문 번호가 존재하지 않습니다',
  orderConfirmed: "이 주문은 확인되었습니다",
  purchaseNotPass: '구매 승인되지 않음',
  saveOrder: '입고 주문 저장',
  orderSuccess: '입고 성공',
  code: '바코드',
  existCode: '이미 존재함',
  deleteBarcode: '바코드를 삭제하시겠습니까?',
  deleteBarcodeSuccess: '삭제 성공',
  clearCode: '바코드를 지우시겠습니까?',
  clear: '바코드 지우기',
  existBarcode: '입력된 바코드:',
  outboundType: '출고 유형',
  inboundType: '입고 유형',
  preOutOrder: '자재 요청 출고(사전 출고)',
  outSuccess: '출고 성공',
  tempIn: '임시 입고',
  tempOut: '임시 출고',
  preIn: '사전 입고 수량',
  preOut: '사전 출고 수량',
  product: '제품',
  salesOrder: '판매 주문',
  outOrder: '출고 주문',
  specialOutbound: '특수 자재 출고(요청 목록)',
  exportExcel: '엑셀 내보내기',
  packingExportConfirm: '분류 명세서를 내보내시겠습니까?',
  specialMaterialList: '특수 자재 목록',
  specialOutSuccess: '특수 자재 출고 성공',
  specialOutFail: '특수 자재 출고 실패',
  normalMaterialList: '공용 재고 목록',
  count: '재고 수량',
  thirdPartyBatch: '공급업체 배치 번호',

  inOK: "입고 성공",
  outOK: "출고 성공",
  inFail: "입고 실패",
  outFail: "출고 실패",

  // 재고 관리
  materialList: '자재 목록',
  locationList: '위치 목록',
  realMaterialList: "보유 재고",
  locationCode: '위치 코드',
  searchMaterialPlaceholder: '자재 코드/이름 검색',
  searchLocationPlaceholder: '위치 코드 검색',
  searchBatchPlaceholder: '배치 번호/공급업체 배치 번호 검색',
  searchMultiCodePlaceholder: '재고 코드 검색(여러 개는 공백으로 구분)',
  batchList: '배치 목록',
  materialDetail: '자재 세부정보',
  lotCount: '배치 수량',
  locationDetail: '위치 세부정보',
  barcodeList: '바코드 목록',
  state: '상태',
  lotItemLocationId: '배치 위치 ID',
  viewBarcode: '바코드 보기',
  batchNo: '배치 번호',
  deliveryBatchNo: '배송 배치 번호',
  supplierBatchNo: '공급업체 배치 번호',
  labels: '라벨',
  addLocation: '위치 추가',
  editLocation: '위치 편집',
  locationIndex: '위치 인덱스',
  label1: '라벨 1',
  label2: '라벨 2',
  label3: '라벨 3',
  label4: '라벨 4',
  label5: '라벨 5',
  locationDescPlaceholder: '위치 설명을 입력해 주세요',
  addLocationSuccess: '위치 추가 성공',
  addLocationFailed: '위치 추가 실패',
  updateLocationSuccess: '위치 업데이트 성공',
  updateLocationFailed: '위치 업데이트 실패',
  l1Required: 'L1은 비워둘 수 없습니다',
  l2Required: 'L2는 비워둘 수 없습니다',
  l3Required: 'L3은 비워둘 수 없습니다',
  l4Required: 'L4는 비워둘 수 없습니다',
  l5Required: 'L5는 비워둘 수 없습니다',
  l1RequiredFirst: '먼저 L1을 작성해 주세요',
  l2RequiredFirst: '먼저 L2를 작성해 주세요',
  l3RequiredFirst: '먼저 L3을 작성해 주세요',
  l4RequiredFirst: '먼저 L4를 작성해 주세요',

  // 새로운 i18n 구성
  location: '위치',
  locationLabel: '위치 라벨',
  selectLocation: '위치 선택',
  searchLocation: '위치 검색',
  locationExist: '이 위치가 이미 존재합니다',
  editBarcodes: '바코드 편집',
  fetchError: '데이터 가져오기 실패',
  barcodesExceedCount: '바코드 수량이 위치 수량을 초과할 수 없습니다',
  checkBarcodes: '바코드를 확인해 주세요',
  barcodesExceedNewCount: '바코드 수량이 새로 설정된 위치 수량을 초과합니다. 먼저 바코드를 조정해 주세요',
  barcodesAutoTrimmed: '바코드가 자동으로 잘렸습니다',
  barcodesAutoTrimmedDesc: '바코드 수량이 위치 수량을 초과하여 처음 {{count}}개의 바코드를 자동으로 유지했습니다',
  totalExceedItemCount: '총 수량이 제한을 초과합니다',
  totalExceedItemCountDesc: '위치 총 수량 {{current}}이 주문 항목 수량 {{total}}을 초과합니다',
  cannotAddLocation: '위치를 추가할 수 없습니다',
  totalReachedItemCount: '위치 총 수량이 주문 항목 수량 {{total}}에 도달했습니다',
  inboundSuccess: '입고 성공',
  inboundFailed: '입고 실패',
  quantityMismatch: '수량 불일치',
  quantityMismatchDesc: '다음 제품의 위치 수량 합계가 주문 수량과 일치하지 않습니다:',
  currentTotal: '현재 합계',
  requiredTotal: '필요한 총계',
  changeLocation: '위치 변경',
  partialInboundSuccess: '부분 입고 성공',
  removeOldLocationsFailed: '이전 위치 데이터 지우기 실패',
  barcodeCount: '바코드 개수',
  someItemsInboundFailed: '일부 제품 입고 실패',
  inboundResultDetail: '{{success}}개 제품 입고 성공, {{failed}}개 제품 입고 실패',
  failedItems: '실패한 제품',
  noBarcodes: '바코드 데이터가 없습니다',

  outNo: "출고 주문 번호",
  innerNo: "내부 주문 번호",
  outData: "출고 날짜",
  outWare: "출고 창고",
  llorg: "자재 요청 부서",
  llper: "자재 요청자",
  documentType: "문서 유형: ",
  outper: "출고 담당자",
  inper: "입고 담당자",
  wareper: "창고 관리자",
  outCheckDate: "감사 날짜",

  returnRn: "반품 사유: ",
  surplus: "정상 잔액 반품",
  defective: "불량품 반품",
  refurbished: "불량품 가공",
  forceReturn: "반품을 확인하시겠습니까?",
  barcodeErr: "바코드 오류",
  forceInbound: "강제 입고 하시겠습니까?",
  forceInboundFailed: "강제 입고 실패",
  forcedErr: "강제 입고 실패",
  moveLoc: "위치 이동",
  targetLocation: "대상 위치",
  moveCount: "이동 수량",
  maxMoveCount: "최대 이동 수량",
  moveFail: "이동 실패",
  moveCurTip: "대상 위치는 현재 위치와 같을 수 없습니다",
  pleaseSelectLocation: "위치를 선택해 주세요",
  pleaseInputCount: "수량을 입력해 주세요",
  countExceedMax: "수량이 최대값을 초과합니다",
  reoutrecvdpicking: "잘못된 출고 픽킹",

  locationIndexExsist: '위치 인덱스: {{index}}이 이미 존재합니다',

  // 위치 출고
  locationOutbound: "위치 출고",
  outNum: "출고 수량",
  outBarcodes: "출고 바코드",
  selectBarcode: "바코드 선택",
  confirmOutboundTip: "출고를 확인하시겠습니까?",
  confirmOutboundDesc: "선택한 배치에 대해 출고 작업을 수행하시겠습니까?",
  inventoryMismatch: "재고 데이터 불일치, 데이터를 다시 확인해 주세요",

  // 바코드 및 스캔 시트 관련
  unsavedData: "저장되지 않은 데이터가 있습니다",
  cancelWithoutSave: "취소 후 데이터를 복구할 수 없습니다",
  confirmDeleteBarcode: "바코드를 삭제하시겠습니까?",
  deleteCannotRecover: "삭제 후 데이터를 복구할 수 없습니다",
  confirmDeleteScanSheet: "스캔 시트를 삭제하시겠습니까?",
  scanSheet: "스캔 시트",
  completeScanSheetInbound: "스캔 시트 완료, 입고 확인",
  barcodesNotInOriginal: "다음 바코드가 원래 바코드 목록에 존재하지 않습니다: {{barcodes}}",
  barcodeDuplicateInLocations: "바코드 {{barcode}}이 {{locationCodes}}에서 중복됩니다",

  // 바코드 생성 관련
  validationFailed: "검증 실패",
  dataInvalid: "데이터가 유효하지 않습니다. 각 스캔 시트 데이터는 {{max}}을 초과할 수 없습니다",
  generateFailed: "생성 실패",
  maxBarcodeCount: "최대 바코드 수량 제한 {{count}}개에 도달했습니다",
  batchGenerateBarcodes: "일괄 바코드 생성",
  optional: "선택 사항",

  // 반품 관련
  returnStockModal: "반품",
  orderList: "주문 목록",
  leastOneMove: "적어도 하나의 배치 이동 수량이 0보다 커야 합니다",
  confirmPreOut: "사전 출고를 실행하시겠습니까?",
  sign: "서명",
  signed: "서명됨",
  signSucc: "서명 성공",
  signFail: "서명 실패",
  plSignDate: "서명 날짜 선택",
  productRef: "제품 추천",
  selectProduct: "제품 선택",
  productExists: "제품이 이미 존재합니다",
  addLocationRef: "위치 제품 연결 추가",
  confirmBatchDelete: "선택한 위치 제품 연결을 일괄 삭제하시겠습니까?",
  confirmDeleteItem: "이 위치 제품 연결을 삭제하시겠습니까?",
  allocatePreOut: "사전 출고 할당",
  allocatePreOutSuccess: "사전 출고 할당 성공",
  allocatePreOutFail: "사전 출고 할당 실패",

  // 수동 입고 관련
  manualInbound: "수동 입고",
  complete: "완료",
  delete: "삭제",
  productCode: "제품 코드",
  productName: "제품 이름",
  productModel: "제품 모델",
  uom: "단위",
  noData: "데이터 없음",
  previous: "이전",
  next: "다음",
  confirm: "확인",
  notRecommendedLocation: "선택한 위치는 추천 위치가 아닙니다",
  isNotRef: "이 창고 위치는 추천 위치가 아닙니다",
  recommendedLocations: "추천 위치",
  allLocations: "전체 위치",
  locationsRequired: "각 제품에 위치를 추가해주세요",
  locationCountRequired: "위치 수량은 공백이거나 0일 수 없습니다",
  inboundComplete: "입고 완료",
  inboundSuccessDesc: "입고 작업이 성공적으로 완료되었습니다",
  otherOut: "기타 출고",
  outNumNotZ: "출고 수량은 0일 수 없습니다",
  outNumExceedStock: "출고 수량이 가용 재고를 초과합니다",
  productInput: "자재 입력",
  locNumnotOrder: "로케이션 총 수량이 입고 수량과 일치하지 않습니다. 수정해 주십시오",
  outOvernum: "출고 수량이 {{num}}개 초과되었습니다",
  outLossnum: "출고 수량이 {{num}}개 부족합니다",
  outboundLocationError: "다음 자재에 출고 로케이션이 없습니다",
  outboundCountMismatch: "다음 자재의 출고 수량이 출고 예정 수량과 일치하지 않습니다. 데이터를 수정해 주십시오",
  noStock: "재고 없음",
  delOutTip: "사전 출고 주문 {{number}}이(가) 생성되었습니다. 삭제하시겠습니까?",
  inputer: "작성자",
  confirmer: "확인자",
  locFailed: "로케이션 정보가 주문 정보와 일치하지 않습니다. 확인해 주십시오.",
  reMatchTip: "출고 확인 실패, 재고 재매칭 필요",
  reMatchSucc: "로케이션이 재할당되었으며 데이터가 업데이트되었습니다",
  reMatchFail: "재고 재매칭 실패",
  delInTip: "사전 입고 주문 {{number}}이(가) 생성되었습니다. 삭제하시겠습니까?",
  delInSucc: "사전 입고 주문 {{number}} 생성 성공",
  inboundUpdateSucc: "사전 입고 주문 데이터가 업데이트되었습니다",
  delOrderClose: "주문 삭제",
  notDelClose: "주문 유지",
  needPrefit: '사전 점검 중 문제가 발생했습니다. 아래 출고 배치 정보를 수정해야 합니다.',
  needSucc: '사전 점검 성공. 출고 데이터를 수정할 필요가 없습니다.',
  needFail: '사전 점검 실패. 재고 정보를 가져오지 못했습니다.',
  outPrefit: '출고 사전 점검',
  fixOut: '출고 수정',
  fixSucc: '출고 정보 수정 성공!',
  fixFail: '출고 정보 수정 실패!',
  outQtyErr: '출고 수량 할당 오류!',
  fetchStockError: '재고 가져오기 실패!',
  oldItemInfo: '원본 출고 정보',
  returnInfo: '반품 입고 주문 정보',
  delReturnClose: "반품 입고 주문 {{number}}이(가) 생성되었습니다. 삭제하시겠습니까?",
  confirmReturnTip: "반품 입고를 확인하시겠습니까?",
  returnNumber: "반품 입고 주문 번호",
  noUseStock: "사용 가능한 재고가 없습니다",
  noLotStock: "해당 반품 배치에 재고가 없습니다: {{lot}}",
  noCodeStock: "해당 자재에 재고가 없습니다: {{code}}",
  returnLot: "반품 배치",
  needFix: "출고 확인 실패. 출고 사전 점검 및 정보 수정 또는 재고 재할당하세요.",
  rePreout: "재고 재할당",
  orderCount: "이번 출고 수량",
  useAmtReq: "필요 총 수량",
  pickingOutbound_m: "자재 출고",
  productOldCount: "확인 전 자재 수량",
  productNewCount: "확인 후 자재 수량",
  lotItemOldCount: "확인 전 배치 수량",
  lotItemNewCount: "확인 후 배치 수량",
  noconf: "미확인",
  confed: "확인됨",
  plconfed: "확인되었습니까?",
  refNo: "참조 번호",
  proIn: "생산 입고",
  locProNot: "재고 부족: 로케이션: {{locIdx}}, 자재 {{proCode}}",
  signTime: "서명 시간",
  prodTempIn: "생산 입고 (임시)",
  iqcState: "품질 검사 상태",
  notIqc: "미검사",
  iqcEd: "검사 완료",
  iqcCheck: "IQC 검사",
  iqcList: "IQC 검사 목록",
  iqcNumber: "검사 번호",
  iqcInventory: "입출고 번호",
  iqcType: "검사 유형",
  iqcUser: "검사자",
  iqcRes: "검사 결과",
  iqcTime: "검사 시간",
  toQc: "검사 대기",
  qcIng: "검사 중",
  passQc: "합격",
  failQc: "불합격",
  front: "외관 불량",
  size: "치수 불량",
  power: "성능 불량",
  package: "포장 불량",
  tag: "표시 불량",
  other: "기타",
  dispReturn: "반품",
  dispAcpt: "양보 인수",
  dispRedo: "재작업",
  qcInbound: "입고 검사",
  qcOutbound: "출고 검사",
  qcWarehouse: "재고 검사",
  qcProgress: "공정 검사",
  qcReturn: "반품 검사",
  typePl: "검사 유형 선택",
  statePl: "검사 상태 선택",
  fetchErr: "검사 조회 실패!",
  createdAt: "작성 시간",
  creator: "작성자",
  desc: "검사 비고",
  qcItems: "검사 항목",
  checkCount: "검사 수량",
  passCount: "합격 수량",
  failCount: "불량 수량",
  qcResult: "검사 결과",
  defectType: "불량 유형",
  disposition: "처리 결과",
  doc: "첨부파일",
  remarks: "비고",
  qcItemList: "검사 자재 목록",
  addQc: "QC 검사 추가",
  qcOrder: "검사 주문",
  selectInventory: "입출고 선택",
  writeQc: "검사 정보 입력",
  itemCount: "주문 수량",
  descPl: "검사 비고 입력",
  checkCountPl: "검사 수량 입력",
  passCounPl: "합격 수량 입력",
  failCountPl: "불량 수량 입력",
  qcResultPl: "검사 결과 선택",
  defectTypePl: "불량 유형 선택",
  dispositionPl: "처리 결과 선택",
  qcTyePl: "검사 유형 선택",
  add: "검사 생성",
  addErr: "검사 생성 실패, 데이터 없음",
  addErr1: "검사 생성 실패",
  done: "완료",
  doneTip: "검사 {{number}}이(가) 생성되었습니다!",
  itemDesc: "검사 항목 비고를 입력하세요",
  noUpdate: "업데이트할 데이터가 없습니다. 저장할 필요가 없습니다",
  updateSucc: "저장 성공",
  havePass: "통과됨",
  notPass: "통과 실패!",
  hasUpdata: "저장되지 않은 변경 사항이 있습니다. 저장 후 통과하시겠습니까?",
  canNotPass: "완료 실패",
  canNotPassTip: "모든 검사 항목에 검사 결과가 있는지 확인하세요",
  qcDone: "{{number}} 검사 완료",
  reQc: "재검사",
  doneQC: "검사 완료",
  optSucc: "작업 성공",
  optFail: "작업 실패",
  canAddQc: "검사 주문을 계속 추가할 수 있습니다",
  orderQcDone: "입출고 주문: {{number}} 검사 완료 [{{res}}]",
  normalPrint: "가로 분할",
  verticalPrint: "세로 연속",
  manual: "수동",
  production: "생산",
  purchase: "구매",
  sale: "판매",
  dispose: "이관",
  sourceType: "유형",
  packing: "창고 분류",
  packingNo: "분류 목록 번호",
  perBoxQuantity: "수량/박스",
  perBoxNetWeight: "순중량/박스",
  perBoxGrossWeight: "총중량/박스",
  totalQuantity: "수량",
  totalNetWeight: "순중량",
  totalGrossWeight: "총중량",
  measurements: "치수",
  packingVolume: "부피",
  draft: "임시 저장",
  confirmed: "확인됨",
  shuted: "밀봉됨",
  wasted: "폐기됨",
  packStatus: "분류 상태",
  totalBoxes: "박스 수",
  grossWeight: "총중량",
  netWeight: "순중량",
  totalVolume: "부피",
  delTip: "분류 목록 {{no}}을(를) 폐기하시겠습니까?",
  addPack: "분류 목록 추가",
  inventoryPl: "출고 주문 선택",
  inventoryInPl: "입고 주문 선택",
  orderPl: "입출고 주문 선택",
  packDtl: "분류 목록 상세",
  closeBox: "밀봉",
  openBox: "밀봉 해제",
  killed: "폐기",
  confirmSucc: "확인 성공",
  confirmFail: "확인 실패",
  sealSucc: "밀봉 성공",
  sealFail: "밀봉 실패",
  unSealSucc: "밀봉 해제 성공",
  unSealFail: "밀봉 해제 실패",
  wasteFail: "폐기 실패",
  items: "상품 항목",
  boxes: "분류 상세",
  boxNo: "박스 번호",
  boxBarcode: "박스 바코드",
  lengthMm: "길이(cm)",
  widthMm: "너비(cm)",
  heightMm: "높이(cm)",
  volumeCbm: "부피(cm³)",
  grossWeightG: "총중량(kg)",
  netWeightG: "순중량(kg)",
  packageType: "포장 유형",
  marksNumbers: "마크 및 번호",
  delBoxTip: "{{no}}을(를) 삭제하시겠습니까?",
  addBox: "박스 추가",
  editBox: "박스 {{no}} 편집",
  boxAddItem: "분류",
  boxedCount: "분류 완료 수량",
  plItem: "분류 항목 선택",
  boxEditItem: "분류 정보 수정",
  boxItemQty: "분류 수량",
  declaredUnitPrice: "단가",
  declaredCurrency: "통화",
  hsCode: "HS 코드",
  originPlace: "원산지",
  productNameCn: "중문명",
  productNameEn: "영문명",
  brand: "브랜드",
  brandType: "브랜드 유형",
  packingModel: "모델",
  packingOrigin: "원산지",
  exportBrandName: "수출 브랜드명",
  declaredAmount: "총 금액",
  shutErr: "밀봉 실패",
  weightNeed: "총중량과 순중량을 입력하세요",
  shipmentOut: "출하 출고",
  noShipment: "출하 정보 없음",
  noOrder: "주문 없음",
  outItems: "출고 상세",
  plPreLOcTypes: "출고 매칭 위치 유형 선택",
  shipOutData: "출하 출고 데이터",
  outDone: "출고 완료",
  noBox: "박스가 없거나 비어 있습니다!",
  needPre: "배송 출고 주문에 먼저 재고를 할당하세요",
  selectSaleOrder: "판매 주문 선택",
  noOutOrder: "출고 주문 없음",
  noOutOrderTip: "확인된 출고 주문이 없습니다",
  outOrderFail: "출고 주문 로드 실패",
  selectOutOrder: "출고 주문 선택",
  remainPack: "잔여 분류 수량",
  selectLot: "배치 선택",
  genShip: "배송 주문 생성",
  searchCode: "품번 검색",
  plSelBox: "배송할 박스를 선택하세요",
  plInQuantityLot: "입고 수량과 로트를 입력하세요",
  packOrder: "분류 목록",
  toClose: "밀봉 대기",
  gWeightNeed: "총중량을 입력하세요",
  addOutOrder: "출고 주문 추가",
  sealAllTip: "분류 목록의 모든 박스가 밀봉되었습니다. 확인 후 전체 주문이 자동으로 밀봉됩니다.",
  emptyBox: "빈 박스: {{number}}",
  selectCustomer: "고객 선택",
  selectCustomerPl: "고객을 선택하세요",
  multiBox: "다중 박스 입력",
  addingTip: "박스 수를 입력하세요 (현재 박스 포함)",
  addPackQty: "박스 수",
  newBoxNumber: "새 박스 번호",
  selBoxErr: "선택 항목이 유효하지 않습니다",
  selBoxErrTip1: "포장 완료되었으며 배송 주문이 생성되지 않은 박스만 선택할 수 있습니다",
  selBoxErrTip2: "빈 박스 또는 이미 밀봉된 박스는 선택할 수 없습니다",
  selBoxErrTip3: "다음 박스는 필터링되었습니다",
  batchSeal: "일괄 밀봉",
  plBatchSeal: "밀봉할 박스를 선택하세요",
  batchGross: "일괄 총중량 적용 (체크 시 현재 모든 박스의 총중량이 동기화됩니다)",
  batchSealSucc: "일괄 밀봉 성공",
  batchSealErr: "일괄 밀봉 실패",
  editBoxErr: "박스 중량 수정 실패, 박스 번호: {{number}}",
  sealBoxErr: "밀봉 실패, 박스 번호: {{number}}",
  filterdSeal: "밀봉된 박스와 빈 박스는 무시되었습니다",
  noSealBox: "밀봉할 수 있는 박스가 없습니다",
  sealRange: "밀봉 범위",
  boxNoPl: "박스 번호를 입력하세요",
  reset: "초기화",
  startNo: "시작 박스 번호",
  endNo: "종료 박스 번호",
  searchRange: "검색 범위",
  productType: "제품 유형",
};

export default warehouse;
